<template>
  <!-- wms重置密码 -->
  <div class="content">
    <van-notice-bar background="#E9F0FF" v-if="type === 'reset'">
      <van-icon slot="left-icon" name="info" color="#004EFE" size="14" />
      <div style="color:#333;margin-left: 8px;">首次登录请重新设置密码</div>
    </van-notice-bar>
    <!-- 手机号 -->
    <div class="form-box">
      <div class="title">手机号验证</div>
      <div class="input-box">
        <div class="label">手机号</div>
        <input type="number" maxlength="11" v-model="phone" placeholder="请输入手机号" />
      </div>
      <div class="input-box" style="position: relative;">
        <div class="label">验证码</div>
        <input type="number" style="flex: 0.5;" maxlength="6" v-model="code" placeholder="请输入验证码" />
        <button
          class="send-btn"
          :disabled="isSend"
          @click="sendCode"
          :style="{ color: isSend ? '#666' : '#004EFE' }"
        >{{ sendStr }}</button>
      </div>
    </div>
    <!-- 密码 -->
    <div class="form-box">
      <div class="title">
        <div>修改密码</div>
        <div class="desc">密码最少8位，由数字或英文字母组成</div>
      </div>
      <div class="input-box">
        <div class="label">输入密码</div>
        <input type="password" v-model="password" placeholder="请输入新密码" />
      </div>
      <div class="input-box">
        <div class="label">再次确认</div>
        <input type="password" v-model="newPassword" placeholder="再次输入密码" />
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="sub-btn-box">
      <button class="sub-btn" @click="updataPassword">完 成</button>
    </div>
  </div>
</template>

<script>
import { apiSendCode, apiEditPassword } from '@/api/wmsGuide'
export default {
  data () {
    return {
      phone: '',
      password: '',
      newPassword: '',
      code: '',
      sendStr: '获取验证码',
      isSend: false,
      type: 'reset', //可选 'forget'
    }
  },
  mounted () {
    this.phone = this.$route.query.phone ? this.$route.query.phone : ''
    this.type = this.$route.query.phone ? 'reset' : 'forget'
    document.title = this.$route.query.phone ? '重置密码' : '忘记密码'
    window.localStorage.clear()
  },
  methods: {
    // 发送验证码
    sendCode () {
      if (this.isSend) {
        return
      }
      if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      this.isSend = true
      apiSendCode({ phone: this.phone, type: 1 })
        .then((res) => {
          if (res.code === 200) {
            this.validateBtn()
            this.$toast('发送成功！')
            this.isSend = true
          } else {
            this.$toast(res.msg)
            this.isSend = false
          }
        })
        .catch(() => {
          this.isSend = false
          this.$toast('网络错误！')
        })
    },

    // 验证-码发送倒计时
    validateBtn () {
      // 倒计时
      let time = 59
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.sendStr = '获取验证码'
          this.isSend = false
        } else {
          this.sendStr = time + 'S'
          this.isSend = true
          time--
        }
      }, 1000)
    },

    // 重置密码
    updataPassword () {
      if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(this.phone)) {
        this.$toast('请输入手机号')
        return
      } else if (!this.code) {
        this.$toast('请输入验证码')
        return
      } else if (!this.newPassword || !this.newPassword) {
        this.$toast('请输入密码')
        return
      } else if (this.newPassword !== this.password) {
        this.$toast('两次密码输入不一致')
        return
      }
      let data = {
        phone: this.phone,
        newPassword: this.newPassword,
        code: this.code,
      }
      apiEditPassword(data)
        .then((res) => {
          if (res.code === 200) {
            this.$store.commit("set_wmsUserId", res.data.id)
            this.$router.push({
              path: '/InvitationCodeList',
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('网络错误！')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";

.content {
  height: 100vh;
  background: #f7f7f7;
  font-weight: normal;
  font-family: PingFangSC-Regular, PingFang SC;
}
.content >>> .van-notice-bar__content {
  color: #333;
}

.form-box {
  background: #fff;
  .title {
    padding: 10px 20px;
    background: #f7f7f7;
    font-size: 14px;
    color: #666666;
    .desc {
      font-size: 12px;
      color: #999999;
    }
  }
  .input-box {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-right: 20px;
    margin-left: 20px;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    border-bottom: solid 1px #e7e7e7;

    .label {
      width: 98px;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    input {
      padding: 22px 0;
      font-size: 16px;
      display: block;
      flex: 1;
      font-weight: normal;
    }
    .send-btn {
      position: absolute;
      right: 20px;
      padding: 20px 0;
      font-size: 16px;
      color: #004efe;
      line-height: 22px;
      font-weight: normal;
    }
  }
}
.input-box:last-child {
  border: 0;
}
.sub-btn-box {
  margin: 80px 20px 0;
  .sub-btn {
    width: 100%;
    height: 57px;
    line-height: 57px;
    background: #3472fd;
    border-radius: 4px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
